import store from './store';
import user from '../metier/users';

export const dispatchInscriptionUser = (res, data) => {
  const getState = store.getState;
  const result = user.inscriptionUser(res, data, getState);
  store.dispatch({type: 'UPDATE_USER', payload: result});
};

export const dispatchSignOutUser = () => {
  const getState = store.getState;
  const result = user.signOutUser(null, null, getState);
  store.dispatch({type: 'LOGOUT', payload: result});
};
